module.exports = __webpack_public_path__ + "static/media/apteka.0ae57170.svg";